import {
  ErpDataTableV2,
  ErpInputTableV2,
  LoadingOverlayV2,
  BulkDeleteDialog,
  DeleteDialog
} from '@/components/custom/erp';
import { ResizableHandle, ResizablePanel, ResizablePanelGroup } from '@/components/ui/resizable';
import { PhieuChiSearchProvider, usePhieuChiPage } from './context';
import SearchDialog from './components/search-dialog';
import FormDialog from './components/form-dialog';
import { TABLE_PAGE_SIZE } from './constants';
import { ActionBar } from './components';

function PhieuChiPageContent() {
  const page = usePhieuChiPage();

  return (
    <div className='flex h-screen w-full flex-col overflow-hidden'>
      {page.searchDialog.open && (
        <SearchDialog
          open={page.searchDialog.open}
          onClose={page.searchDialog.onClose}
          onSearch={page.searchDialog.onSubmit}
          formState={page.searchDialog.searchFieldStates}
        />
      )}

      {page.multipleFormDialog.open && page.multipleFormDialog.invoiceData.length > 0 && (
        <FormDialog
          formMode='add'
          open={page.multipleFormDialog.open}
          initialData={page.multipleFormDialog.initialData}
          onSubmit={page.multipleFormDialog.onSubmit}
          onClose={page.multipleFormDialog.onClose}
        />
      )}

      {page.editWithUpdatedDialog.open && (
        <>
          {page.editWithUpdatedDialog.isLoading && <LoadingOverlayV2 />}
          {page.editWithUpdatedDialog.detail && (
            <FormDialog
              formMode='edit'
              open={page.editWithUpdatedDialog.open}
              onClose={page.editWithUpdatedDialog.onClose}
              initialData={page.editWithUpdatedDialog.detail}
              onSubmit={page.editWithUpdatedDialog.onSubmit}
              onAdd={page.formDialog.onAdd}
              onEdit={page.formDialog.onEdit}
              onDelete={page.formDialog.onDelete}
              onCopy={page.formDialog.onCopy}
            />
          )}
        </>
      )}

      {page.formDialog.open && !page.multipleFormDialog.open && !page.editWithUpdatedDialog.open && (
        <FormDialog
          formMode={page.formDialog.formMode}
          open={page.formDialog.open}
          onClose={page.formDialog.onClose}
          initialData={
            page.formDialog.formMode === 'add' && !page.formDialog.isCopyMode
              ? undefined
              : page.formDialog.detail || undefined
          }
          onSubmit={page.formDialog.onSubmit}
          onAdd={page.formDialog.onAdd}
          onEdit={page.formDialog.onEdit}
          onDelete={page.formDialog.onDelete}
          onCopy={page.formDialog.onCopy}
        />
      )}

      {page.deleteDialog.open && (
        <DeleteDialog
          open={page.deleteDialog.open}
          onClose={page.deleteDialog.onClose}
          selectedObj={page.deleteDialog.selectedObj}
          deleteObj={page.deleteDialog.onDelete}
          clearSelection={page.deleteDialog.clearSelection}
        />
      )}

      {page.bulkDeleteDialog.open && (
        <BulkDeleteDialog
          title='Phiếu chi'
          onClose={page.bulkDeleteDialog.onClose}
          columns={page.table.columns}
          dataRows={page.table.displayData}
          handleDelete={page.bulkDeleteDialog.onDelete}
        />
      )}

      <div
        className={`flex h-full flex-col ${
          page.formDialog.open || page.multipleFormDialog.open || page.editWithUpdatedDialog.open ? 'hidden' : ''
        }`}
      >
        {page.actions.isExporting && <LoadingOverlayV2 />}

        <ActionBar
          onAdd={page.actions.handleAddClick}
          onEdit={page.actions.handleEditClick}
          onDelete={page.actions.handleDeleteClick}
          onCopy={page.actions.handleCopyClick}
          onSearch={page.actions.handleSearch}
          onRefresh={page.actions.handleRefresh}
          isEditDisabled={!page.selection.selectedObj}
        />

        <ResizablePanelGroup direction='vertical' className='flex-1 overflow-hidden'>
          <ResizablePanel defaultSize={55} minSize={20}>
            <div data-perf-id='pc-master-table' className='h-full w-full overflow-hidden'>
              <ErpDataTableV2
                tables={page.table.tables}
                onRowClick={page.actions.handleRowClick}
                totalItems={page.table.totalItems}
                currentPage={page.table.currentPage}
                onPageChange={page.table.onPageChange}
                onSearchChange={page.table.onSearchChange}
                selectedRowId={page.selection.selectedRowIndex || undefined}
                pageSize={TABLE_PAGE_SIZE}
                loading={page.table.displayIsLoading}
              />
            </div>
          </ResizablePanel>

          <ResizableHandle withHandle className='bg-slate-200/80 hover:bg-slate-300' />

          <ResizablePanel defaultSize={45} minSize={20}>
            <div data-perf-id='pc-bottom-detail-table' className='h-full overflow-hidden'>
              <ErpInputTableV2
                rows={page.detailTable.rows}
                columns={page.detailTable.columns}
                showIndexColumn
                actions={{
                  export: () => console.log('Export clicked'),
                  pin: () => console.log('Pin clicked')
                }}
                actionsDisabled={page.formDialog.formMode === 'view' || !page.selection.selectedObj}
                height='100%'
                loading={page.table.displayIsLoading && !page.selection.selectedObj}
              />
            </div>
          </ResizablePanel>
        </ResizablePanelGroup>
      </div>
    </div>
  );
}

export default function PhieuChiPage() {
  return (
    <PhieuChiSearchProvider>
      <PhieuChiPageContent />
    </PhieuChiSearchProvider>
  );
}
